import {
  faHome,
  faEnvelope,
  faPhone,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { ProfileData } from './DataDefinitions';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface PersonalInfoProps {
  profile?: ProfileData;
  className?: string;
  errors: { email?: string, first_name?: string; last_name?: string; },
  onProfileChange: (name: string, value: any) => void;
}

const PersonalInfo = ({ profile, className, errors, onProfileChange }: PersonalInfoProps) => {

  const { t } = useTranslation();

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    onProfileChange(name, value);
  };

  return (
    <Card className={classNames(className, 'border border-light')}  >
      <Card.Body>
        <h4 className="mb-2">Personal Information</h4>
        <Row className="g-3">
          <Col xs={12} sm={6}>
            <div className="form-icon-container">
              <Form.Floating>
                <Form.Control
                  id="firstName"
                  type="text"
                  placeholder="First Name*"
                  className="form-icon-input"
                  value={profile?.first_name}
                  name="first_name"
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.first_name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.first_name}
                </Form.Control.Feedback>

                <label htmlFor="firstName" className="form-icon-label text-700">
                  {t("PersonalInfo.first_name")}
                </label>
              </Form.Floating>
              <FontAwesomeIcon
                icon={faUser}
                className="text-900 fs-9 form-icon"
              />
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div className="form-icon-container">
              <Form.Floating>
                <Form.Control
                  id="lastName"
                  type="text"
                  placeholder="Last Name*"
                  className="form-icon-input"
                  value={profile?.last_name}
                  name="last_name"
                  onChange={handleInputChange}
                  required
                  isInvalid={!!errors.last_name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.last_name}
                </Form.Control.Feedback>

                <label htmlFor="lastName" className="form-icon-label text-700">
                  {t("PersonalInfo.last_name")}
                </label>
              </Form.Floating>
              <FontAwesomeIcon
                icon={faUser}
                className="text-900 fs-9 form-icon"
              />
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div className="form-icon-container">
              <Form.Floating>
                <Form.Control
                  id="email"
                  type="email"
                  placeholder="Email*"
                  className="form-icon-input"
                  value={profile?.email}
                  name="email"
                  onChange={handleInputChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>

                <label htmlFor="email" className="form-icon-label text-700">
                  {t("PersonalInfo.email")}
                </label>
              </Form.Floating>
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-900 fs-9 form-icon"
              />
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div className="form-icon-container">
              <Form.Floating>
                <Form.Control
                  id="phone_number"
                  type="tel"
                  placeholder="Phone"
                  className="form-icon-input"
                  value={profile?.phone_number}
                  name="phone_number"
                  onChange={handleInputChange}
                />
                <label htmlFor="phone_number" className="form-icon-label text-700">
                  {t("PersonalInfo.phone")}
                </label>
              </Form.Floating>
              <FontAwesomeIcon
                icon={faPhone}
                className="text-900 fs-9 form-icon"
              />
            </div>
          </Col>

          <Col xs={12} sm={6}>
            <div className="form-icon-container">
              <Form.Floating>
                <Form.Control
                  id="location"
                  type="text"
                  placeholder={t("PersonalInfo.location_placeholder")}
                  className="form-icon-input"
                  value={profile?.location}
                  name="location"
                  onChange={handleInputChange}
                />
                <label htmlFor="location" className="form-icon-label text-700">
                  {t("PersonalInfo.location")}
                </label>
              </Form.Floating>
              <FontAwesomeIcon
                icon={faHome}
                className="text-900 fs-9 form-icon"
              />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default PersonalInfo;
